import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import noAccounts from '../../../assets/images/noAccounts.svg';
import {buildContactsManagerAccountsUrl} from '../../../helpers/contactsManagerHelpers';
import {DropdownEmpty} from './dropdownEmpty';

/*
 * Constants.
 */

const contactsManagerAccountsUrl = buildContactsManagerAccountsUrl();

/*
 * Props.
 */

interface DropdownEmptyAccountProps {
  navigateToLink: HandlerOf<string>;
}

/*
 * Style.
 */

const StyledContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
`;

/*
 * Component.
 */

export const DropdownEmptyAccount: FC<DropdownEmptyAccountProps> = ({navigateToLink}) => {
  const onClick = () => navigateToLink(contactsManagerAccountsUrl);

  return (
    <DropdownEmpty imageSource={noAccounts}>
      <StyledContentDiv>
        <span>
          <Trans id="dropdown-account-noresults-text">No accounts</Trans>
        </span>
        <Button variant={ButtonVariantsEnum.PRIMARY} onClick={onClick}>
          <Trans id="dropdown-account-noresults-button">Add account</Trans>
        </Button>
      </StyledContentDiv>
    </DropdownEmpty>
  );
};
